<template>
  <div class="login-view">
    <div class="login-form">
      <div class="login-header">
        <img src="assets/logo1.png" alt="Logo" height="100px">
        <p style="margin-top:0;">SuperChinese</p>
      </div>
      <el-form>
      <el-input
        placeholder="请输入用户名"
        suffix-icon="fa fa-user"
        v-model="username"
        style="margin-bottom: 18px"
      >
      </el-input>

      <el-input
        placeholder="请输入密码"
        suffix-icon="fa fa-keyboard-o"
        v-model="password"
        type="password"
        style="margin-bottom: 18px"
      >
      </el-input>

      <el-input
          placeholder="请输入系统授权码"
          suffix-icon="fa fa-keyboard-o"
          v-model="authCode"
          type="password"
          style="margin-bottom: 18px"
          @keyup.native.enter="login"
      >
      </el-input>

      <p v-show="!!error" style="margin-top:0;color:#F56C6C;">{{error}}</p>

      <el-button
        type="primary" :loading="loginLoading"
        style="width: 100%;margin-bottom: 18px"
        @click.native="login"
      >登录
      </el-button>
      <div>
        <el-checkbox v-model="remenber"> Remenber</el-checkbox>
      </div>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      username: '',
      password: '',
      authCode: '',
      remenber: true,
      loginLoading: false,
      error: ''
    }
  },
  methods: {
    login() {
      this.error = ''
      this.loginLoading = true
      this.$http.post(this.$urls.user_login, {
        username: this.username,
        password: this.password,
        code: this.authCode,
      }).then(res => {
        this.loginLoading = false
        localStorage.removeItem('authKey')
        localStorage.removeItem('accessToken')
        sessionStorage.removeItem('authKey')
        sessionStorage.removeItem('accessToken')
        if (this.remenber) {
          localStorage.setItem('authKey', res.data.auth_key)
          localStorage.setItem('accessToken', res.data.access_token)
        } else {
          sessionStorage.setItem('authKey', res.data.auth_key)
          sessionStorage.setItem('accessToken', res.data.access_token)
        }
        this.$router.push({path: '/'})
      }).catch(error => {
        this.loginLoading = false
        if (error.response && error.response.status === 422) {
          const errors = error.response.data.map(n => n.message).join("\n")
          this.$message.error(errors);
        } else {
          this.$message.error(error.message);
        }
      })
    }
  }
}
</script>

<style lang="scss">
.login-view{
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  height: 100%;
  width: 100%;
  background-color: #4498c4;
  // background: url(/assets/bg.png) repeat-x left bottom;
  // background-size: 20% 100%;
  .login-form{
    width: 375px;
    padding: 30px;
    background-color: white;
    text-align: left;
    border-radius: 4px;
    position: relative;
    margin-bottom: 50px;
    margin-left: 0;
    margin-right: 0;
    zoom: 1;
    display: block;
    .login-header{
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }
}
</style>
